import { Row, Col } from "react-bootstrap";
import PersonReviewed from "./PersonReviewed";
import "./PeopleReviewedList.css";

function PeopleReviewedList({ peopleReviewed }) {
  return (
    <Col className="objectives-list">
      {peopleReviewed.map((element) => (
        <PersonReviewed
          key={element._id}
          id={element._id}
          name={element.name}
          objectives={element.objectives}
          totalScore={element.totalScore}
        />
      ))}
    </Col>
  );
}

export default PeopleReviewedList;
